import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { GET_USER, GET_USERS } from "./queries";
import {
  GetUsers,
  GetUsersVariables,
  GetUser,
  GetUserVariables,
} from "./__generated__/queries";
import { CREATE_USER, DELETE_USER, UPDATE_USER } from "./mutations";
import {
  CreateUser,
  CreateUserVariables,
  UpdateUser,
  UpdateUserVariables,
  DeleteUser,
  DeleteUserVariables,
} from "./__generated__/mutations";

export const useUserCreate = makeMutationHook<CreateUser, CreateUserVariables>(
  CREATE_USER
);

export const useUserListQuery = makeQueryHook<GetUsers, GetUsersVariables>(
  GET_USERS
);

export const useUserDetailsQuery = makeQueryHook<GetUser, GetUserVariables>(
  GET_USER
);

export const useUserUpdateMutation = makeMutationHook<
  UpdateUser,
  UpdateUserVariables
>(UPDATE_USER);

export const useUserDeleteMutation = makeMutationHook<
  DeleteUser,
  DeleteUserVariables
>(DELETE_USER);
